import localeAntd from 'ant-design-vue/lib/locale-provider/en_US'

const messages = {
  topBar: {
    issuesHistory: 'Issues History',
    projectManagement: 'Project Management',
    typeToSearch: 'Search...',
    findPages: 'Find pages...',
    actions: 'Actions',
    status: 'Status',
    profileMenu: {
      hello: 'Hello',
      billingPlan: 'Billing Plan',
      role: 'Role',
      email: 'Email',
      phone: 'Phone',
      editProfile: 'Edit Profile',
      logout: 'Logout',
    },
  },
  authForm: {
    loginFailed: 'Login Failed',
    forgotpassFailed: 'Reset Passrowd Failed',
    invalidPassword: 'Invalid Password',
    emailNotFound: 'User Email Not Found',
    systemBusy: 'System seems to be busy, please try again later or contact administrator!',
    tankYou: 'Tank You',
    forgotpassSucces: 'Please check your email for completing reset password',
    passwrdNotmatch: 'Password is different!',
    resetpassFailed: 'Reset Password Failed',
    resetpassSuccess: 'Reset Password Success',
  },
  notification: {
    successAddDiscount: 'Add Discount Voucher Success',
    successDeleteVoucher: 'Delete Voucher Success',
    duplicateVoucherCode: 'Voucher code already exist',
    failedSearchSalesOrder: 'Please select parameter for search sales order',
    failedSearchVoucher: 'Please select parameter for search voucher',
  },
  settings: {
    logo: 'Logo',
    banner: 'Home Banner',
    categoryBanner: 'Category Banner',
    resellerBanner: 'Reseller Banner',

    uploadImage: 'Upload Image',
  },

  product: {
    create: {
      title: 'Add new product',
    },
    edit: {
      title: 'Update product',
    },
  },
}

export default {
  locale: 'en-US',
  localeAntd,
  messages,
}
